/**
 * Toast Notification Utility (PR A10)
 * Routed through sonner — the app-wide <Toaster/> mounted in App.js.
 * (The previous shadcn use-toast store had no mounted renderer, so
 * every toast was silently dropped — USERS-UI-001 fix.)
 */
import { toast as sonnerToast } from 'sonner';

export const toast = {
  success: (message) => sonnerToast.success(message),
  error: (message) => sonnerToast.error(message),
  info: (message) => sonnerToast.info(message),
  warning: (message) => sonnerToast.warning(message),
};

// User action specific toasts
export const userActionToasts = {
  resetPasswordSuccess: () =>
    toast.success('Password reset email sent successfully! User must change password on next login.'),

  lockSuccess: () =>
    toast.success('Account locked.'),

  unlockSuccess: () =>
    toast.success('Account unlocked.'),

  impersonateSuccess: () =>
    toast.success('Impersonation started.'),

  impersonateEnd: () =>
    toast.success('Impersonation ended.'),

  actionFailed: (message) =>
    toast.error(`Action failed: ${message || 'Unknown error'}`),

  rateLimitExceeded: () =>
    toast.error('Too many requests. Try again shortly.'),

  permissionDenied: () =>
    toast.error('You don\'t have permission for this action.')
};
